import { useEffect, useState } from 'react';
import { FileText, Paperclip } from 'lucide-react';
import { api } from '@/lib/api';

type Msg = {
  id: string;
  role: string;
  content: string;
  attachmentUrl?: string | null;
  attachmentName?: string | null;
  attachmentMime?: string | null;
  metadata?: { kind?: string; transcricao?: string | null } | null;
};

type Props = {
  message: Msg;
  conversationId: string;
  portal?: boolean;
};

export function AtendimentoMediaBubble({ message, conversationId, portal = true }: Props) {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const isAudio =
    message.metadata?.kind === 'audio' ||
    Boolean(message.attachmentMime?.startsWith('audio/'));
  const isImage = Boolean(message.attachmentMime?.startsWith('image/'));
  const hasFile = Boolean(message.attachmentUrl);

  useEffect(() => {
    if (!hasFile) return;
    let revoked: string | null = null;
    const path = portal
      ? `/rique-atendimento/portal/conversations/${conversationId}/messages/${message.id}/attachment`
      : `/rique-atendimento/conversations/${conversationId}/messages/${message.id}/attachment`;
    void (async () => {
      try {
        const res = await api.get(path, { responseType: 'blob' });
        const url = URL.createObjectURL(res.data);
        revoked = url;
        setBlobUrl(url);
      } catch {
        setBlobUrl(null);
      }
    })();
    return () => {
      if (revoked) URL.revokeObjectURL(revoked);
    };
  }, [conversationId, hasFile, message.id, portal]);

  return (
    <div className="space-y-1">
      {message.content ? <div className="whitespace-pre-wrap">{message.content}</div> : null}
      {hasFile && isImage && blobUrl ? (
        <a href={blobUrl} target="_blank" rel="noreferrer">
          <img
            src={blobUrl}
            alt={message.attachmentName || 'imagem'}
            className="max-h-48 rounded-md border object-contain"
          />
        </a>
      ) : null}
      {hasFile && isAudio && blobUrl ? (
        <audio controls src={blobUrl} className="w-full max-w-xs mt-1" />
      ) : null}
      {hasFile && !isImage && !isAudio ? (
        <a
          href={blobUrl || '#'}
          download={message.attachmentName || 'anexo'}
          className="inline-flex items-center gap-1 text-xs underline opacity-90"
          onClick={(e) => {
            if (!blobUrl) e.preventDefault();
          }}
        >
          <Paperclip className="w-3 h-3" />
          {message.attachmentName || 'Baixar anexo'}
        </a>
      ) : null}
      {hasFile && isAudio && !blobUrl ? (
        <span className="inline-flex items-center gap-1 text-xs opacity-70">
          <FileText className="w-3 h-3" /> Áudio
        </span>
      ) : null}
    </div>
  );
}
